/**
* Session.ts
* @copyright Microsoft 2019
*/
import dynamicProto from "@microsoft/dynamicproto-js";
import { isString, objDefineAccessors } from "@microsoft/1ds-core-js";
function _getId() {
    return this.getId();
}
function _setId(id) {
    this.setId(id);
}
var Session = /** @class */ (function () {
    function Session() {
        dynamicProto(Session, this, function (_self) {
            _self.setId = function (id) {
                _self.customId = id;
            };
            _self.getId = function () {
                if (isString(_self.customId)) {
                    return _self.customId;
                }
                else {
                    return _self.automaticId;
                }
            };
        });
    }
    Session.prototype.setId = function (id) {
        // @DynamicProtoStub - DO NOT add any code as this will be removed during packaging
    };
    Session.prototype.getId = function () {
        // @DynamicProtoStub - DO NOT add any code as this will be removed during packaging
        return null;
    };
    /**
     * Static constructor, attempt to create accessors
     */
    Session._staticInit = (function () {
        // Dynamically create get/set property accessors
        objDefineAccessors(Session.prototype, "id", _getId, _setId);
    })();
    return Session;
}());
export { Session };
//# sourceMappingURL=Session.js.map